import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import GeneralTablesCellsTdLinkBase from 'lumen/components/general/tables/cells/td-link-base';

interface GeneralTablesCellsTdLinkSignature {
  Args: {
    cellData: {
      formattedValue: string;
      iconAfter?: IconName | 'blank';
      iconBefore?: IconName;
      isRedirectDisabled?: boolean;
      onClickHandler?: () => void;
      redirectUrl: string;
    };
  };
}

export default class GeneralTablesCellsTdLink extends Component<GeneralTablesCellsTdLinkSignature> {
  @action onClickHandler(): void {
    this.args.cellData.onClickHandler?.();
  }

  <template>
    {{#if @cellData.isRedirectDisabled}}
      <span class="text-200--regular prism-link--disabled truncate">
        <GeneralTablesCellsTdLinkBase @cellData={{@cellData}} />
      </span>
    {{else if @cellData.redirectUrl}}
      <a
        class="prism-link text-200--medium truncate"
        href={{@cellData.redirectUrl}}
        {{on "click" this.onClickHandler}}
        rel="noopener noreferrer"
        target="_blank"
      >
        <GeneralTablesCellsTdLinkBase @cellData={{@cellData}} />
      </a>
    {{else}}
      <GeneralTablesCellsTdLinkBase @cellData={{@cellData}} />
    {{/if}}
  </template>
}
